
export default {
  imgUrl: function(imgText) {
    return imgText;
  },
}